import { render, staticRenderFns } from "./DistributeDetails.vue?vue&type=template&id=0b87c574&scoped=true"
import script from "./DistributeDetails.vue?vue&type=script&lang=js"
export * from "./DistributeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87c574",
  null
  
)

export default component.exports